import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback, useEffect, useRef } from "react";
import LogoLottie from "@hl/base-components/lib/assets/animations/logo-lottie.json";
import { useLottie } from "lottie-react";
const AnimatedLogo = () => {
    const timeoutRef = useRef();
    const playRef = useRef();
    const stopRef = useRef();
    const scheduleNextAnimation = useCallback(() => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        const nextInterval = Math.random() * (60000 - 15000) + 15000;
        timeoutRef.current = setTimeout(() => {
            var _a;
            (_a = playRef.current) === null || _a === void 0 ? void 0 : _a.call(playRef);
            scheduleNextAnimation();
        }, nextInterval);
    }, []);
    const handleAnimationComplete = useCallback(() => {
        var _a;
        (_a = stopRef.current) === null || _a === void 0 ? void 0 : _a.call(stopRef);
        scheduleNextAnimation();
    }, [scheduleNextAnimation]);
    const options = {
        animationData: LogoLottie,
        loop: false,
        autoplay: false,
        style: { height: "20px" },
        onComplete: handleAnimationComplete,
    };
    const { View, play, stop } = useLottie(options);
    playRef.current = play;
    stopRef.current = stop;
    useEffect(() => {
        scheduleNextAnimation();
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [scheduleNextAnimation]);
    const handleMouseEnter = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        play();
    };
    return _jsx("div", { onMouseEnter: handleMouseEnter, children: View });
};
export default AnimatedLogo;
